import EmptyCourses from './EmptyCourses';

export default EmptyCourses;
